'use client'
import * as React from 'react'
import { useTranslations } from 'next-intl'
import { Divider } from 'components/divider'
import Image from 'next/image'

import type { Variant } from '../config'
import { useConfig } from '../../_hooks/use-config'

export function ProductDetails({
  variant,
  loading = false,
}: {
  variant: Variant
  loading?: boolean
}) {
  const t = useTranslations('pages.b.product_details')
  const { subtotal, currency } = useConfig(variant)

  const formattedSubtotal = `${currency?.symbol}${subtotal}`

  return (
    <div className="flex w-full flex-col">
      <h3 className="text-16 font-bold uppercase">{t('title')}</h3>
      <Divider className="my-[10px] hidden bg-[#e3e1e9] lg:block" />
      <div className="flex w-full py-5">
        <div className="flex w-full flex-row shadow-[3px_1px_12px_0px_rgba(0,_0,_0,_0.12)] lg:p-0">
          {variant === 'yearly' || variant === 'yearlyPromo' ? (
            <div className="flex w-full max-w-[150px] items-center rounded-l bg-[linear-gradient(#f2f2f2_66%,_rgba(242,242,242,0))]">
              <Image
                width={150}
                height={160}
                src="https://www.creativefabrica.com/wp-content/themes/creativefabricanew/assets/images/subscriptions/246178.png"
                alt="Product image"
                className="rounded-l"
              />
            </div>
          ) : (
            <div className="flex h-[100px] items-center rounded-l" />
          )}
          <div className="flex min-h-[80px] w-full flex-col rounded-r px-[15px] py-[10px]">
            <div className="flex h-full flex-row gap-2">
              <div className="flex w-full flex-col justify-between gap-[2px]">
                <h3 className="text-12 md:text-16 font-bold">
                  {variant === 'monthly' ? t('variants.monthly.title') : null}
                  {variant === 'yearly' || variant === 'yearlyPromo' || variant === 'aiStudio'
                    ? t('variants.yearly.title', {
                        subscriptionName:
                          variant === 'aiStudio'
                            ? t('subscription_names.ai_studio')
                            : t('subscription_names.all_access'),
                      })
                    : null}
                </h3>
                {variant === 'monthly' ? (
                  <div className="flex gap-2 md:hidden">
                    <h2 className="text-[18px] font-semibold leading-[26px]">
                      {t.rich('variants.monthly.price', {
                        // oxlint-disable-next-line no-negated-condition
                        price: !loading ? formattedSubtotal : '',
                      })}
                    </h2>
                  </div>
                ) : null}
                <div className="md:text-14 mt-[10px] hidden text-[11px] md:mt-0 md:block">
                  &nbsp;
                </div>
              </div>
              {variant === 'monthly' ? (
                <div className="hidden flex-col justify-between md:flex">
                  <h2 className="text-[18px] font-semibold leading-[26px]">
                    {t.rich('variants.monthly.price', {
                      // oxlint-disable-next-line no-negated-condition
                      price: !loading ? formattedSubtotal : '',
                    })}
                  </h2>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
